module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJhJREFUOBHdkkESgCAIRbX7X8cOU4chmGIsFJFFNBOLRMHfE0jpawOA7RUGFAaP8OJJ9uSqwghYiJKNRNm/1jL6UdaCdFmL8XlGY1+uKrFM9O7/Jbwazx82z7hbwzPNrNkpxdUYyR7zS6RkRHN6zbdbkmYOWeT+LMvvzXNcKSy62XgosTW/ErrbPJmk7r1NDS2FRr1rgdDzAypyaiO/DME1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignCenter_normal.png
// module id = 303
// module chunks = 0